// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__RkvHf","content":"styles_content__YAxiM","selectAll":"styles_selectAll__CukqQ"};